import { render, staticRenderFns } from "./ProposalPersonalInfoView.vue?vue&type=template&id=22c6a944&scoped=true&"
import script from "./ProposalPersonalInfoView.vue?vue&type=script&lang=js&"
export * from "./ProposalPersonalInfoView.vue?vue&type=script&lang=js&"
import style0 from "./ProposalPersonalInfoView.vue?vue&type=style&index=0&id=22c6a944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c6a944",
  null
  
)

export default component.exports